// 产品 / 案例统一数据目录（驱动产品列表页与产品详情页）
// 文案以客户价值为导向，简洁凝练，不写技术细节。

// ---- 生成式产品/案例主图 ----
// 用 productArt 生成接近真实的“软件控制台 / 系统架构图 / 分析看板”，每个产品各具特征。
// 均为程序生成的抽象示意，不含任何真实项目截图或客户信息。
import { architectureArt, dashboardArt } from './productArt'

// 三个大模型采用三种结构完全不同的架构图，确保彼此明显区分：
// PowerMind → 检索增强问答流水线；IndustMind → 中心辐射能力中台；OpsMind → 分层预训练微调。
const imgPowermind = architectureArt({
  style: 'pipeline', title: 'PowerMind 电力大模型 · 检索增强问答', accent: '#2f80ed',
  sources: ['安全规程', '机组台账', '历史事故'],
  coreLabel: '电力垂域大模型', tasks: ['操作校验', '故障归因', '应急方案']
})
const imgIndustmind = architectureArt({
  style: 'radial', title: 'IndustMind 工业大模型 · 工艺能力中台', accent: '#00a6a6',
  sources: ['工艺知识 知识接入', '加工数据 数据接入', '质检数据 质量接入'],
  coreLabel: '工业工艺大模型',
  capabilities: ['工艺优化', '工艺生成', '质量预测', '零件选型', '知识问答', '异常识别']
})
const imgMtmind = architectureArt({
  style: 'layered', title: 'OpsMind 智能运维大模型 · 多模态基底模型', accent: '#6c5ce7',
  devices: ['旋转设备', '电气设备', '工业机器人', '管道阀门'],
  modalities: ['振动信号', '设备图像', '电流数据'],
  coreLabel: 'Transformer 基底模型', tasks: ['状态监测', '故障诊断', '寿命预测'],
  scenes: ['小样本', '持续学习', '迁移泛化'],
  leftHeader: '基底模型预训练', rightHeader: '全设备微调'
})

// 能源 / 机械 / 化工 / 零碳 / 数字孪生：软件控制台与分析看板
const imgPowertrade = dashboardArt({
  title: '电力现货交易系统', subtitle: '电价预测 · 智能申报 · 策略复盘', accent: '#2d9cdb', layout: 'tabs', variant: 'line',
  menu: ['交易总览', '电价预测', '申报盯盘', '策略复盘', '收益分析'],
  kpis: [{ value: '¥1.2亿', label: '累计收益' }, { value: '94%', label: '预测准确率' }, { value: '36', label: '托管场站' }, { value: '24h', label: '智能盯盘' }]
})
const imgWind = dashboardArt({
  title: '风电装备智能运维系统', subtitle: '风机状态监测 · 故障预警', accent: '#27ae60', layout: 'control', variant: 'gauge',
  menu: ['风场总览', '机组监测', '叶片诊断', '齿轮箱', '预警中心'],
  kpis: [{ value: '320', label: '在线风机' }, { value: '7-14d', label: '提前预警' }, { value: '+2%', label: '发电量提升' }, { value: '-12%', label: '运维成本' }]
})
const imgThermal = dashboardArt({
  title: '热电厂智能运维系统', subtitle: '快速部署 · 实时响应 · 稳定运行', accent: '#f2994a', layout: 'console', variant: 'line',
  menu: ['机组总览', '设备监测', '点检管理', '告警处理', '运维报表'],
  kpis: [{ value: '20min', label: '异常响应' }, { value: '1天', label: '快速部署' }, { value: '12月', label: '投资回本' }, { value: '99%', label: '可用率' }]
})
const imgBiofuel = dashboardArt({
  title: '生物质燃料智能分析系统', subtitle: '热值分析 · 质检追溯 · 公允结算', accent: '#219653', layout: 'tabs', variant: 'bar',
  menu: ['入厂总览', '热值分析', '质检风控', '批次追溯', '结算管理'],
  kpis: [{ value: '98%', label: '热值精度' }, { value: '实时', label: '掺杂识别' }, { value: '全程', label: '质检追溯' }, { value: '↑', label: '结算公允' }]
})
const imgValve = dashboardArt({
  title: '控制阀选型设计生成系统', subtitle: '智能选型 · 自动生成 · 降低门槛', accent: '#2f80ed', layout: 'console', variant: 'flow',
  menu: ['选型工作台', '工况输入', '智能选型', '图纸生成', '方案导出'],
  kpis: [{ value: '1000+', label: '日选型能力' }, { value: '≈100%', label: '选型准确率' }, { value: '分钟级', label: '方案生成' }, { value: '↓', label: '人员门槛' }]
})
const imgMachineQuality = dashboardArt({
  title: '机床加工质量预测系统', subtitle: '过程预测 · 减少废品 · 稳定质量', accent: '#00a6a6', layout: 'control', variant: 'line',
  menu: ['产线总览', '质量预测', '工艺参数', '废品分析', '报表中心'],
  kpis: [{ value: '加工中', label: '实时预测' }, { value: '-30%', label: '废品率' }, { value: '即装即用', label: '快速接入' }, { value: '95%', label: '预测精度' }]
})
const imgProcessOptimize = dashboardArt({
  title: '工艺参数智能优化系统', subtitle: '参数寻优 · 提质增效 · 经验沉淀', accent: '#6c5ce7', layout: 'tabs', variant: 'line',
  menu: ['优化总览', '参数寻优', '方案对比', '效果评估', '知识库'],
  kpis: [{ value: '自动', label: '参数寻优' }, { value: '+18%', label: '加工效率' }, { value: '一致', label: '质量稳定' }, { value: '沉淀', label: '工艺经验' }]
})
const imgAnomaly = dashboardArt({
  title: '零件异常检测系统', subtitle: '全流程监控 · 异常预警 · 快速处置', accent: '#eb5757', layout: 'control', variant: 'scatter',
  menu: ['监控总览', '实时检测', '异常预警', '问题定位', '处置记录'],
  kpis: [{ value: '全流程', label: '过程监控' }, { value: '实时', label: '异常报警' }, { value: '自动', label: '问题定位' }, { value: '-批量损失', label: '降低损失' }]
})
const imgSchedule = dashboardArt({
  title: '产线多订单生产进度预测系统', subtitle: '进度透明 · 科学排产 · 准时交付', accent: '#2d9cdb', layout: 'console', variant: 'gantt',
  menu: ['排产总览', '进度预测', '订单跟踪', '延期预警', '调度建议'],
  kpis: [{ value: '多订单', label: '进度透明' }, { value: '提前', label: '延期预警' }, { value: '科学', label: '智能排产' }, { value: '准时', label: '按时交付' }]
})
const imgMetro = dashboardArt({
  title: '地铁智能运维系统', subtitle: '健康评估 · 智能诊断 · 安全运行', accent: '#56ccf2', layout: 'geo', variant: 'map',
  menu: ['1号线 正常', '2号线 预警', '3号线 正常', '4号线 检修', '5号线 正常', '调度中心 在线'],
  kpis: [{ value: '多级', label: '健康评估' }, { value: '智能', label: '故障诊断' }, { value: '7×24', label: '在线监测' }, { value: '安全', label: '可靠运行' }]
})
const imgRobotDiagnosis = dashboardArt({
  title: '工业机器人智能诊断系统', subtitle: '故障诊断 · 健康评估 · 维护优化', accent: '#9b51e0', layout: 'control', variant: 'gauge',
  menu: ['产线总览', '机器人监测', '健康评估', '故障诊断', '维护策略'],
  kpis: [{ value: '多品牌', label: '广泛适配' }, { value: '实时', label: '健康评估' }, { value: '↑', label: '产线稼动率' }, { value: '优化', label: '维护策略' }]
})

// 数字孪生
const imgGearTwin = dashboardArt({
  title: '重载传动齿轮寿命预测系统', subtitle: '寿命预测 · 计划检修 · 风险降低', accent: '#2f80ed', layout: 'console', variant: 'rul',
  menu: ['装备总览', '健康监测', '寿命预测', '检修计划', '风险评估'],
  kpis: [{ value: '可视', label: '寿命趋势' }, { value: '计划', label: '主动检修' }, { value: '↓', label: '突发停机' }, { value: '90%', label: '预测精度' }]
})
const imgThermalTwin = dashboardArt({
  title: '火电核心部件智能诊断系统', subtitle: '状态感知 · 智能诊断 · 稳定运行', accent: '#eb5757', layout: 'control', variant: 'gauge',
  menu: ['机组总览', '部件监测', '状态评估', '智能诊断', '预警中心'],
  kpis: [{ value: '核心部件', label: '状态感知' }, { value: '提前', label: '隐患预警' }, { value: '智能', label: '故障诊断' }, { value: '稳定', label: '连续运行' }]
})
const imgPowerTwin = dashboardArt({
  title: '电站关键设备运维大模型', subtitle: '设备孪生 · 统一管理 · 辅助决策', accent: '#6c5ce7', layout: 'tabs', variant: 'flow',
  menu: ['电站总览', '设备孪生', '健康评估', '运维建议', '决策中心'],
  kpis: [{ value: '孪生', label: '设备建模' }, { value: '统一', label: '多系统管理' }, { value: '智能', label: '运维建议' }, { value: '高效', label: '辅助决策' }]
})

// 化工
const imgAmmonia = dashboardArt({
  title: '脱硝精准喷氨智能系统', subtitle: '精准控氨 · 节能环保 · 保护设备', accent: '#27ae60', layout: 'control', variant: 'gauge',
  menu: ['运行总览', '喷氨控制', '排放监测', '能耗分析', '报表中心'],
  kpis: [{ value: '-10%', label: '尿素喷量' }, { value: '达标', label: '氨逃逸' }, { value: '数十万', label: '年化效益' }, { value: '延寿', label: '保护设备' }]
})
const imgChem = dashboardArt({
  title: '化工园区智能管控系统', subtitle: '智能管控 · 工艺优化 · 安全风控', accent: '#f2994a', layout: 'geo', variant: 'map',
  menu: ['一期装置 正常', '二期装置 正常', '罐区 预警', '公用工程 正常', '应急中心 在线', '环保监测 正常'],
  kpis: [{ value: '全流程', label: '智能管控' }, { value: '持续', label: '工艺优化' }, { value: '智能', label: '风险预警' }, { value: '合规', label: '安全生产' }]
})

// 零碳园区
const imgCarbonPlatform = dashboardArt({
  title: '数字双碳管理平台', subtitle: '碳排监测 · 智能核算 · 节能优化', accent: '#27ae60', layout: 'tabs', variant: 'line',
  menu: ['双碳总览', '碳排监测', '智能核算', '节能优化', '碳报告'],
  kpis: [{ value: '全景', label: '碳排监测' }, { value: '自动', label: '碳核算' }, { value: '智能', label: '节能识别' }, { value: '达标', label: '双碳目标' }]
})
const imgCarbonGov = dashboardArt({
  title: '政府产业园区双碳管理', subtitle: '区域监测 · 企业画像 · 决策支撑', accent: '#2f80ed', layout: 'geo', variant: 'map',
  menu: ['高新片区 达标', '装备制造园 预警', '化工集中区 监测', '物流园区 达标', '商务区 达标', '监管中心 在线'],
  kpis: [{ value: '区域', label: '能碳监测' }, { value: '画像', label: '重点企业' }, { value: '评估', label: '绿色发展' }, { value: '支撑', label: '科学决策' }]
})
const imgCarbonEnterprise = dashboardArt({
  title: '企业双碳管理', subtitle: '精细核算 · 用能优化 · 绿色合规', accent: '#00a6a6', layout: 'console', variant: 'bar',
  menu: ['企业总览', '碳排核算', '用能优化', '合规管理', '碳资产'],
  kpis: [{ value: '清晰', label: '碳家底' }, { value: '优化', label: '用能结构' }, { value: '↓', label: '用能成本' }, { value: '合规', label: '绿色运营' }]
})
const imgCarbonBuilding = dashboardArt({
  title: '建筑双碳管理', subtitle: '能耗监测 · 用能优化 · 低碳运营', accent: '#219653', layout: 'tabs', variant: 'bar',
  menu: ['建筑总览', '能耗监测', '用能优化', '设备管理', '低碳报表'],
  kpis: [{ value: '实时', label: '能耗监测' }, { value: '智能', label: '用能优化' }, { value: '↓', label: '运行成本' }, { value: '绿色', label: '低碳建筑' }]
})

// ---- 机器人 ----
import robGaoya from '@/assets/hardware/rob_gaoya.png'
import robShengjiang from '@/assets/hardware/rob_shengjiang.png'
import rob6dof from '@/assets/hardware/rob_6dof.png'
import robOutdoor from '@/assets/hardware/rob_outdoor.png'
import robFangbao from '@/assets/hardware/rob_fangbao.png'
import rob4wheel from '@/assets/hardware/rob_4wheel.png'
import robQiangci from '@/assets/hardware/rob_qiangci.png'
import robTrack from '@/assets/hardware/rob_track.png'
import robDianjian from '@/assets/hardware/rob_dianjian.png'
import robLogistics from '@/assets/hardware/rob_logistics.png'

// ---- 传感器 ----
import senVibe from '@/assets/hardware/sen_vibe.png'
import senWind from '@/assets/hardware/sen_wind.png'
import senMag from '@/assets/hardware/sen_mag.png'
import senDeform from '@/assets/hardware/sen_deform.png'
import senTempvibe from '@/assets/hardware/sen_tempvibe.png'
import senSound from '@/assets/hardware/sen_sound.png'
import senTemp from '@/assets/hardware/sen_temp.png'
import senSelf from '@/assets/hardware/sen_self.png'

// ---- 边缘算力 ----
import cmpJian from '@/assets/hardware/cmp_jian.png'
import cmpDi from '@/assets/hardware/cmp_di.png'
import cmpZhong from '@/assets/hardware/cmp_zhong.png'
import cmpGao from '@/assets/hardware/cmp_gao.png'
import cmpChao from '@/assets/hardware/cmp_chao.png'
import cmpEdge from '@/assets/hardware/cmp_edge.png'

const robotGallery = [
  { img: robGaoya, name: '高压巡检机器人', tag: '巡检', desc: '配电室、室内开关室、通讯室' },
  { img: robShengjiang, name: '升降轮式巡检机器人', tag: '巡检', desc: '机房、配电室、GIS室、汽机房' },
  { img: rob6dof, name: '六自由度轮式巡检机器人', tag: '巡检', desc: '室内开关室、GIS室、汽机房、主厂房' },
  { img: robOutdoor, name: '室外轮式巡检机器人', tag: '巡检', desc: '升压站、室外开关室、厂区' },
  { img: robFangbao, name: '轮式防爆巡检机器人', tag: '巡检', desc: '园区、油库、装置区' },
  { img: robTrack, name: '轨道式巡检机器人', tag: '巡检', desc: '机房、配电室' },
  { img: rob4wheel, name: '高防护四轮驱动机器人', tag: '特殊作业', desc: 'GIS室、汽机房、循泵房' },
  { img: robQiangci, name: '强磁环境巡检机器人', tag: '特殊作业', desc: '电解槽底、整流器室等强磁环境' },
  { img: robDianjian, name: '低压配电间机器人', tag: '特殊作业', desc: '低压配电室及类似操作场景' },
  { img: robLogistics, name: '工业物流机器人', tag: '物流', desc: '半导体、电子、新能源等行业' }
]

const sensorGallery = [
  { img: senVibe, name: '振动俘能器', tag: '自取能', desc: '采集振动能量，免布线免换电' },
  { img: senWind, name: '微风俘能器', tag: '自取能', desc: '采集微风能量，持续自供电' },
  { img: senMag, name: '磁场俘能器', tag: '自取能', desc: '采集磁场能量，稳定供能' },
  { img: senDeform, name: '形变传感器', tag: '感知', desc: '监测结构形变与应力' },
  { img: senTempvibe, name: '温振传感器', tag: '感知', desc: '同步监测温度与振动' },
  { img: senSound, name: '声音传感器', tag: '感知', desc: '采集设备声纹特征' },
  { img: senTemp, name: '温度传感器', tag: '感知', desc: '精准监测设备温度' },
  { img: senSelf, name: '自供能传感器', tag: '自取能', desc: '无需外接电源，长期免维护' }
]

const computeGallery = [
  { img: cmpJian, name: '简配方案', tag: '2U', desc: '128/256 TFLOPs 算力' },
  { img: cmpDi, name: '低配方案', tag: '4U', desc: '128 TFLOPs 算力' },
  { img: cmpZhong, name: '中配方案', tag: '4U', desc: '256 TFLOPs 算力' },
  { img: cmpGao, name: '高配方案', tag: '8U', desc: '512 TFLOPs 算力' },
  { img: cmpChao, name: '超高配方案', tag: '46U', desc: '1024 TFLOPs 算力' },
  { img: cmpEdge, name: '边缘计算分析盒', tag: '边缘', desc: '集成华为310P，内置行业大模型' }
]

// 分类元信息
export const categories = [
  { id: 'llm', name: '工业大模型', subtitle: '以大模型为核心的行业垂域智能底座' },
  { id: 'energy', name: '能源', subtitle: '火电、风电、新能源交易与智能运维' },
  { id: 'machinery', name: '机械', subtitle: '机械装备智能运维、工艺优化与质量预测' },
  { id: 'digital-twin', name: '数字孪生', subtitle: '关键装备与生产系统的虚实融合诊断预测' },
  { id: 'chemical', name: '化工', subtitle: '化工生产的智能管控与节能降耗' },
  { id: 'carbon', name: '零碳园区', subtitle: '建筑、企业、园区双碳一体化管理' },
  { id: 'hardware', name: '智能硬件', subtitle: '机器人、传感器、边缘算力' }
]

// 全部产品/案例
export const products = [
  // ===== 工业大模型 =====
  {
    slug: 'powermind', category: 'llm', name: 'PowerMind 电力大模型', hero: imgPowermind,
    tagline: '懂电力的智能大脑，让经验人人可用',
    intro: '面向电力行业的垂域大模型，把资深专家的经验沉淀为人人可用的智能助手。能力覆盖电力基本知识问答、机组动态优化、标准化操作校验、故障多维归因、事故应急方案、安全规程匹配六大方面，广泛适用于火电、风电、光伏、电网等各类电力场景。',
    values: [
      { icon: 'fas fa-comments', title: '知识问答 · 规程匹配', desc: '一句话查询电力知识与安全规程，毫秒级精准匹配。' },
      { icon: 'fas fa-sliders', title: '机组优化 · 操作校验', desc: '辅助机组动态优化，自动校验标准化操作，规范作业。' },
      { icon: 'fas fa-shield-halved', title: '故障归因 · 应急方案', desc: '多维归因快速定位故障，一键生成事故应急方案。' }
    ]
  },
  {
    slug: 'industmind', category: 'llm', name: 'IndustMind 工业大模型', hero: imgIndustmind,
    tagline: '制造企业的“工艺大脑”，让经验沉淀可复用',
    intro: '面向制造企业的“工艺大脑”，帮助企业提质、降本、增效。能力覆盖工艺参数优化、工艺智能生成、加工质量预测、零件智能选型、知识问答、异常识别等方面，广泛适用于机械等离散工业场景，让工艺知识不再依赖个别老师傅。',
    values: [
      { icon: 'fas fa-sliders', title: '工艺优化 · 智能生成', desc: '自动寻优工艺参数，一键生成工艺方案，告别反复试错。' },
      { icon: 'fas fa-magnifying-glass-chart', title: '质量预测 · 异常识别', desc: '加工中预测质量、实时识别异常，守住质量底线。' },
      { icon: 'fas fa-wand-magic-sparkles', title: '智能选型 · 知识问答', desc: '辅助零件智能选型，沉淀工艺知识随问随答。' }
    ]
  },
  {
    slug: 'mtmind', category: 'llm', name: 'OpsMind 智能运维大模型', hero: imgMtmind,
    tagline: '一套底座，适用于所有设备运维场景',
    intro: '国内首创的通用智能运维底座，融合设备图像、振动、电流等多模态数据，提供状态监测、故障诊断、寿命预测等统一能力。无需为每类设备单独建模，一套模型即可适用于电厂、化工、机械、轨道交通、工业机器人等所有设备运维场景。',
    values: [
      { icon: 'fas fa-cubes', title: '一个底座', desc: '多模态统一建模，适用于各行业、各类工业设备运维。' },
      { icon: 'fas fa-bell', title: '监测预警', desc: '状态监测、故障诊断、寿命预测，隐患在故障前发现。' },
      { icon: 'fas fa-arrow-trend-up', title: '越用越准', desc: '支持小样本快速适配与持续学习，场景越多越聪明。' }
    ]
  },
  // ===== 能源 =====
  {
    slug: 'powertrade', category: 'energy', name: '电力现货交易系统', hero: imgPowertrade,
    tagline: '电力现货交易全流程智能托管，对收益负责',
    intro: '为新能源场站与售电公司提供电力现货交易的全流程智能托管，从预测、申报到复盘一站搞定。',
    values: [
      { icon: 'fas fa-chart-line', title: '精准预测', desc: '结合多源数据预测电价与电量，把握交易机会。' },
      { icon: 'fas fa-handshake-angle', title: '无忧全托管', desc: '提供360度交易托管，降低整体运营成本。' },
      { icon: 'fas fa-rotate', title: '收益负责', desc: '策略可复盘、过程可追溯，持续优化收益。' }
    ]
  },
  {
    slug: 'wind-om', category: 'energy', name: '风电装备智能运维系统', hero: imgWind,
    tagline: '秒级识别风机隐患，提前预警、降本增收',
    intro: '依托电力大模型底座，秒级识别风机叶片裂纹、齿轮箱点蚀等隐患，让风场运维从“被动抢修”转向“主动预防”。',
    values: [
      { icon: 'fas fa-bell', title: '提前预警', desc: '故障提前7-14天预警，减少非计划停机。' },
      { icon: 'fas fa-coins', title: '降低成本', desc: '大部件更换成本降低约12%。' },
      { icon: 'fas fa-plug-circle-bolt', title: '增发电量', desc: '全场发电量提升约2%，年增收可观。' }
    ]
  },
  {
    slug: 'thermal-om', category: 'energy', name: '热电厂智能运维系统', hero: imgThermal,
    tagline: '一天部署、20分钟响应、约一年回本',
    intro: '面向热电厂的快速部署智能运维方案，无需停产即可上线，让设备从定期巡检升级为按需点检。',
    values: [
      { icon: 'fas fa-screwdriver-wrench', title: '快速部署', desc: '一天无感部署、无需停产打孔。' },
      { icon: 'fas fa-stopwatch', title: '快速响应', desc: '异常20分钟内推送，故障响应时间大幅缩短。' },
      { icon: 'fas fa-piggy-bank', title: '快速回本', desc: '可用率提升、检修费用下降，约12个月回本。' }
    ]
  },
  {
    slug: 'biofuel', category: 'energy', name: '生物质燃料智能分析系统', hero: imgBiofuel,
    tagline: '燃料热值可量化、质检可追溯、结算更公允',
    intro: '面向生物质电厂的燃料热值智能分析与质检风控平台，破解燃料“掺杂使假、热值不清”难题。',
    values: [
      { icon: 'fas fa-fire-flame-curved', title: '热值可量化', desc: '结合化验与历史数据精准推导燃料热值。' },
      { icon: 'fas fa-shield-halved', title: '防作弊', desc: '自动识别异常批次，质检结果可追溯。' },
      { icon: 'fas fa-scale-balanced', title: '结算公允', desc: '燃烧更稳定、结算更公允，综合降本增效。' }
    ]
  },
  // ===== 机械 =====
  {
    slug: 'valve', category: 'machinery', name: '高端控制阀选型设计生成系统', hero: imgValve,
    tagline: '选型从每天十台到上千台，又快又准',
    intro: '用大模型重塑高端控制阀的选型设计，把过去依赖资深工程师的繁琐选型，变成又快又准的智能服务。',
    values: [
      { icon: 'fas fa-gauge-high', title: '效率跃升', desc: '选型效率从每天约10台提升到上千台。' },
      { icon: 'fas fa-circle-check', title: '质量保证', desc: '选型准确率接近100%，显著减少返工。' },
      { icon: 'fas fa-user-gear', title: '降低门槛', desc: '大幅降低对资深选型人员的依赖。' }
    ]
  },
  {
    slug: 'machine-quality', category: 'machinery', name: '机床加工质量预测系统', hero: imgMachineQuality,
    tagline: '加工中预测质量，把废品消灭在产生前',
    intro: '在加工过程中实时预测零件质量，让质量问题在出现前就被发现，减少废品与返工。',
    values: [
      { icon: 'fas fa-wave-square', title: '实时预测', desc: '加工中即可预测表面质量，无需等待检测。' },
      { icon: 'fas fa-recycle', title: '减少废品', desc: '提前发现异常，降低废品率与返工成本。' },
      { icon: 'fas fa-plug', title: '易于落地', desc: '传感器即装即用，快速接入现有产线。' }
    ]
  },
  {
    slug: 'process-optimize', category: 'machinery', name: '零件加工工艺参数智能优化系统', hero: imgProcessOptimize,
    tagline: '智能寻优工艺参数，告别反复试错',
    intro: '基于工业大模型自动寻优加工工艺参数，帮助企业稳定提升加工效率与一致性。',
    values: [
      { icon: 'fas fa-magnifying-glass-chart', title: '自动寻优', desc: '智能推荐最优工艺参数，告别反复试错。' },
      { icon: 'fas fa-arrow-up-right-dots', title: '提质增效', desc: '提升加工一致性与效率。' },
      { icon: 'fas fa-database', title: '经验沉淀', desc: '把工艺经验沉淀为企业可复用的资产。' }
    ]
  },
  {
    slug: 'anomaly', category: 'machinery', name: '零件异常检测系统', hero: imgAnomaly,
    tagline: '加工全流程实时监控，守住质量底线',
    intro: '对零件加工全流程进行高效监控与智能分析，第一时间发现异常，避免批量损失。',
    values: [
      { icon: 'fas fa-eye', title: '全流程监控', desc: '覆盖加工全过程，异常无处遁形。' },
      { icon: 'fas fa-triangle-exclamation', title: '及时预警', desc: '实时识别异常并报警，减少批量损失。' },
      { icon: 'fas fa-diagram-project', title: '智能分析', desc: '自动定位问题，辅助快速处置。' }
    ]
  },
  {
    slug: 'schedule', category: 'machinery', name: '产线多订单生产进度预测系统', hero: imgSchedule,
    tagline: '多订单进度看得清，交付计划心中有数',
    intro: '面向多订单离散制造车间，精准预测各订单生产进度，让排产与交付计划更科学。',
    values: [
      { icon: 'fas fa-list-check', title: '进度透明', desc: '实时预测各订单生产进度。' },
      { icon: 'fas fa-truck-fast', title: '准时交付', desc: '提前识别延期风险，保障按时交付。' },
      { icon: 'fas fa-calendar-check', title: '科学排产', desc: '为排产与调度提供数据支撑。' }
    ]
  },
  {
    slug: 'metro', category: 'machinery', name: '地铁智能运维系统', hero: imgMetro,
    tagline: '实时健康评估，保障列车安全可靠运行',
    intro: '为地铁打造的智慧运维监测平台，通过实时健康评估与智能诊断，保障列车与站内设备安全可靠运行。',
    values: [
      { icon: 'fas fa-heart-pulse', title: '实时健康', desc: '对设备进行多级健康评估，状态一目了然。' },
      { icon: 'fas fa-stethoscope', title: '智能诊断', desc: '智能故障诊断与预测，防患于未然。' },
      { icon: 'fas fa-shield-halved', title: '安全可靠', desc: '提升地铁数字化、智能化运维水平。' }
    ]
  },
  {
    slug: 'robot-diagnosis', category: 'machinery', name: '工业机器人智能诊断系统', hero: imgRobotDiagnosis,
    tagline: '为工业机器人保驾护航，优化维护策略',
    intro: '依托国家级重点专项研发，为工业机器人提供智能故障诊断与健康评估，提升自动化产线稼动率。',
    values: [
      { icon: 'fas fa-robot', title: '广泛适配', desc: '已在KUKA、广数、隆深等机器人上应用。' },
      { icon: 'fas fa-heart-pulse', title: '健康评估', desc: '实时评估机器人健康状态。' },
      { icon: 'fas fa-screwdriver-wrench', title: '优化维护', desc: '改进维护策略，提升产线稼动率。' }
    ]
  },
  // ===== 数字孪生 =====
  {
    slug: 'gear-life-twin', category: 'digital-twin', name: '重载传动齿轮寿命预测系统', hero: imgGearTwin,
    tagline: '关键部件寿命看得见，检修计划更从容',
    intro: '面向重载传动装备的数字孪生系统，持续评估齿轮健康状态与寿命趋势，帮助企业提前安排检修，减少突发停机。',
    values: [
      { icon: 'fas fa-gears', title: '寿命可视', desc: '关键齿轮寿命趋势清晰呈现。' },
      { icon: 'fas fa-calendar-check', title: '计划检修', desc: '提前安排检修窗口，减少被动抢修。' },
      { icon: 'fas fa-shield-halved', title: '降低风险', desc: '降低重大装备故障与停机风险。' }
    ]
  },
  {
    slug: 'thermal-core-twin', category: 'digital-twin', name: '火电核心部件智能诊断系统', hero: imgThermalTwin,
    tagline: '核心部件状态实时掌握，隐患提前发现',
    intro: '面向火电关键设备的数字孪生诊断系统，帮助运维人员及时掌握核心部件健康状态，提升设备运行可靠性。',
    values: [
      { icon: 'fas fa-heart-pulse', title: '状态感知', desc: '核心部件健康状态一目了然。' },
      { icon: 'fas fa-bell', title: '提前预警', desc: '提前发现异常趋势，辅助快速处置。' },
      { icon: 'fas fa-industry', title: '稳定运行', desc: '提升机组运行安全性与连续性。' }
    ]
  },
  {
    slug: 'power-equipment-twin', category: 'digital-twin', name: '电站关键设备运维大模型', hero: imgPowerTwin,
    tagline: '以数字孪生连接设备、模型与运维决策',
    intro: '面向电站关键设备的数字孪生运维平台，将设备状态、健康评估与运维建议集中呈现，让管理更直观、决策更高效。',
    values: [
      { icon: 'fas fa-cube', title: '设备孪生', desc: '关键设备状态集中建模与展示。' },
      { icon: 'fas fa-sitemap', title: '统一管理', desc: '多设备、多系统状态统一呈现。' },
      { icon: 'fas fa-chart-line', title: '辅助决策', desc: '为检修、巡检和运维决策提供依据。' }
    ]
  },
  // ===== 化工 =====
  {
    slug: 'ammonia', category: 'chemical', name: '脱硝精准喷氨智能系统', hero: imgAmmonia,
    tagline: '精准控氨、降低氨逃逸，经济环保双丰收',
    intro: '面向电厂与化工锅炉的脱硝精准喷氨智能控制系统，精准控氨、降低氨逃逸，带来显著的经济与环保效益。',
    values: [
      { icon: 'fas fa-coins', title: '节约成本', desc: '节约尿素喷量约10%，单台机组年效益数十万元。' },
      { icon: 'fas fa-leaf', title: '减少处罚', desc: '降低氨逃逸超标带来的环保处罚。' },
      { icon: 'fas fa-gears', title: '保护设备', desc: '减少积灰堵塞与设备腐蚀，延长设备寿命。' }
    ]
  },
  {
    slug: 'chem-park', category: 'chemical', name: '化工园区智能管控系统', hero: imgChem,
    tagline: '生产全流程智能管控，安全与效率兼得',
    intro: '面向化工园区的智能管控方案，融合工业大模型实现生产全流程的智能监控、工艺优化与安全风控。',
    values: [
      { icon: 'fas fa-desktop', title: '智能管控', desc: '生产全流程高效监控与智能分析。' },
      { icon: 'fas fa-sliders', title: '工艺优化', desc: '结合大模型持续优化工艺与质量。' },
      { icon: 'fas fa-shield-halved', title: '安全风控', desc: '风险智能预警，提升安全合规水平。' }
    ]
  },
  // ===== 零碳园区 =====
  {
    slug: 'carbon-platform', category: 'carbon', name: '数字双碳管理平台', hero: imgCarbonPlatform,
    tagline: '碳排监测、核算到节能优化的一体化平台',
    intro: '一体化的数字双碳管理平台，提供从碳排放监测、核算到节能优化的全业务自动化解决方案。',
    values: [
      { icon: 'fas fa-chart-pie', title: '全景监测', desc: '碳排放、能耗全景监测，数据实时可视。' },
      { icon: 'fas fa-calculator', title: '智能核算', desc: '自动化碳核算与报告，省时省力。' },
      { icon: 'fas fa-leaf', title: '节能降碳', desc: '智能识别节能空间，助力双碳目标。' }
    ]
  },
  {
    slug: 'carbon-gov', category: 'carbon', name: '政府产业园区双碳管理', hero: imgCarbonGov,
    tagline: '园区能碳全景监测，绿色发展决策支撑',
    intro: '面向政府与产业园区的双碳管理平台，实现园区能碳全景监测与产业绿色低碳发展评估。',
    values: [
      { icon: 'fas fa-city', title: '区域监测', desc: '园区能碳全景监测，掌握整体态势。' },
      { icon: 'fas fa-industry', title: '企业画像', desc: '重点企业碳排画像，精准管理。' },
      { icon: 'fas fa-compass-drafting', title: '决策支撑', desc: '为绿色低碳发展提供决策支撑。' }
    ]
  },
  {
    slug: 'carbon-enterprise', category: 'carbon', name: '企业双碳管理', hero: imgCarbonEnterprise,
    tagline: '摸清碳家底，优化用能，绿色合规',
    intro: '面向企业的双碳管理方案，帮助企业摸清碳家底、优化用能结构、实现绿色低碳运营。',
    values: [
      { icon: 'fas fa-calculator', title: '精细核算', desc: '碳排放精细核算，家底一清二楚。' },
      { icon: 'fas fa-plug-circle-check', title: '用能优化', desc: '优化用能结构，降低用能成本。' },
      { icon: 'fas fa-certificate', title: '绿色合规', desc: '满足绿色合规要求，提升品牌价值。' }
    ]
  },
  {
    slug: 'carbon-building', category: 'carbon', name: '建筑双碳管理', hero: imgCarbonBuilding,
    tagline: '建筑能耗精细化管理与优化',
    intro: '面向建筑场景的双碳管理方案，对建筑能耗与碳排放进行精细化管理与优化。',
    values: [
      { icon: 'fas fa-building', title: '能耗监测', desc: '建筑能耗实时监测，问题可视。' },
      { icon: 'fas fa-plug-circle-check', title: '用能优化', desc: '智能优化用能，降低运行成本。' },
      { icon: 'fas fa-leaf', title: '绿色建筑', desc: '助力绿色建筑与低碳运营。' }
    ]
  },
  // ===== 智能硬件 =====
  {
    slug: 'robots', category: 'hardware', name: '机器人', hero: robOutdoor,
    tagline: '巡检 · 特殊作业 · 物流，替代高频高危作业',
    intro: '覆盖巡检、特殊作业、物流等多场景的工业机器人，适配电网、煤炭、石化等行业，替代人工完成高频、高危、重复作业。',
    values: [
      { icon: 'fas fa-map-location-dot', title: '多场景覆盖', desc: '适配电网、煤炭、石化等多行业场景。' },
      { icon: 'fas fa-helmet-safety', title: '替代高危', desc: '替代人工进入高危、强磁、防爆等环境。' },
      { icon: 'fas fa-clock', title: '7×24小时', desc: '全天候自主作业，稳定高效。' }
    ],
    gallery: robotGallery
  },
  {
    slug: 'sensors', category: 'hardware', name: '传感器', hero: senVibe,
    tagline: '自取能、免布线，稳定可靠的数据来源',
    intro: '自主研发的工业传感器与俘能器，部分可自取能、免布线免换电，为设备状态监测提供稳定可靠的数据来源。',
    values: [
      { icon: 'fas fa-battery-full', title: '自供能', desc: '俘能器自取能，免布线、免换电。' },
      { icon: 'fas fa-wave-square', title: '多物理量', desc: '覆盖振动、温度、声音、形变等感知。' },
      { icon: 'fas fa-shield-halved', title: '稳定可靠', desc: '工业级品质，长期免维护。' }
    ],
    gallery: sensorGallery
  },
  {
    slug: 'edge-compute', category: 'hardware', name: '边缘算力', hero: cmpEdge,
    tagline: '多档算力 + 边缘盒，本地部署更安全',
    intro: '从简配到超高配的多档算力方案，并提供集成华为310P芯片的边缘计算分析盒，可在企业本地部署行业垂域大模型。',
    values: [
      { icon: 'fas fa-server', title: '多档可选', desc: '从简配到超高配，灵活匹配需求。' },
      { icon: 'fas fa-microchip', title: '本地部署', desc: '边缘盒集成华为310P，内置行业大模型。' },
      { icon: 'fas fa-lock', title: '数据安全', desc: '数据不出厂，保障企业数据安全。' }
    ],
    gallery: computeGallery
  }
]

import { i18n } from '@/i18n'
import { productsEn, categoriesEn } from './catalogEn'

function localizeProduct(p) {
  if (!p || i18n.locale !== 'en') return p
  const e = productsEn[p.slug]
  if (!e) return p
  return {
    ...p,
    name: e.name || p.name,
    tagline: e.tagline || p.tagline,
    intro: e.intro || p.intro,
    subtitle: e.subtitle || p.subtitle,
    values: e.values || p.values,
    gallery: p.gallery
      ? p.gallery.map((g, i) => {
        const ge = e.gallery && e.gallery[i]
        return ge ? { ...g, name: ge.name || g.name, desc: ge.desc || g.desc, tag: ge.tag || g.tag } : g
      })
      : p.gallery
  }
}

function localizeCategory(c) {
  if (!c || i18n.locale !== 'en') return c
  const e = categoriesEn[c.id]
  return e ? { ...c, name: e.name || c.name, subtitle: e.subtitle || c.subtitle } : c
}

export function getProduct(slug) {
  return localizeProduct(products.find(p => p.slug === slug))
}

export function getProductsByCategory(catId) {
  return products.filter(p => p.category === catId).map(localizeProduct)
}

export function getCategory(catId) {
  return localizeCategory(categories.find(c => c.id === catId))
}

export function getCategories() {
  return categories.map(localizeCategory)
}
